const gradeNumber = (value) => {
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : null;
};

export const compareByGradeOrder = (a, b) => {
  const numA = gradeNumber(a);
  const numB = gradeNumber(b);
  if (numA !== null && numB !== null) return numA - numB;
  if (numA !== null) return -1;
  if (numB !== null) return 1;
  return a.localeCompare(b);
};
